import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ErrorResponseWithIdI } from 'src/app/core/models/error-response-with-id.interface';

import { DictionaryI } from 'src/app/dictionaries/models/dictionary.interface';
import {
  EstablishmentTypesAction,
  EstablishmentTypesActionTypes,
} from 'src/app/dictionaries/store/actions/establishment-types.action';

const selectId = (dictionary: DictionaryI) => dictionary.name;
const adapter: EntityAdapter<DictionaryI> = createEntityAdapter<DictionaryI>({
  selectId,
});

export interface EstablishmentTypesReducerState
  extends EntityState<DictionaryI> {
  loading: boolean;
  loaded: boolean;
  error: ErrorResponseWithIdI;
}

export const initialEstablishmentTypesReducerState: EstablishmentTypesReducerState = adapter.getInitialState(
  {
    loading: false,
    loaded: false,
    error: null,
  }
);

export function establishmentTypesReducer(
  state: EstablishmentTypesReducerState = initialEstablishmentTypesReducerState,
  action: EstablishmentTypesAction
): EstablishmentTypesReducerState {
  switch (action.type) {
    case EstablishmentTypesActionTypes.LoadEstablishmentTypes: {
      return {
        ...state,
        loading: true,
      };
    }

    case EstablishmentTypesActionTypes.LoadedEstablishmentTypesSuccess: {
      return adapter.addMany(action.payload, {
        ...state,
        loading: false,
        loaded: true,
      });
    }

    case EstablishmentTypesActionTypes.LoadedEstablishmentTypesFail: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case EstablishmentTypesActionTypes.CleanEstablishmentTypesState: {
      return {
        ...initialEstablishmentTypesReducerState,
      };
    }

    default: {
      return state;
    }
  }
}

export const getEstablishmentTypesIds = adapter.getSelectors().selectIds;
export const getEstablishmentTypesEntities = adapter.getSelectors()
  .selectEntities;
export const getAllEstablishmentTypes = adapter.getSelectors().selectAll;
export const getEstablishmentTypesTotal = adapter.getSelectors().selectTotal;

export const getEstablishmentTypesLoading = (
  state: EstablishmentTypesReducerState
) => state.loading;
export const getEstablishmentTypesLoaded = (
  state: EstablishmentTypesReducerState
) => state.loaded;
export const getEstablishmentTypesError = (
  state: EstablishmentTypesReducerState
) => state.error;
